
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/api/channels",
      function () {
        return require("private-next-pages/docs/antara/api/channels/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/api/channels"])
      });
    }
  